import { TColor } from "@amphore-dev/amphore-lib";

import { THoursStats } from "@/types";

export const getDeltaColor = (delta: number): string => {
	if (delta < -10) return "text-red-700 bg-red-700"; // Significantly negative
	if (delta < -5) return "text-red-500 bg-red-500"; // Moderately negative
	if (delta < 0) return "text-yellow-500 bg-yellow-500"; // Slightly negative
	if (delta < 1) return "text-green-500 bg-green-500"; // Slightly positive
	if (delta < 2) return "text-lime-500 bg-lime-500"; // Moderately positive
	return "text-primary-500 bg-primary-500"; // Significantly positive
};

/**
 * Same bands as `getDeltaColor`, mapped to the lib's fixed `TColor` palette
 * instead of raw Tailwind classes — for components taking a semantic
 * `color` prop (e.g. `Progress`) rather than a className. No "lime" token
 * in `TColor`: the two positive bands both collapse to "success".
 */
export const getDeltaColorToken = (delta: number): TColor => {
	if (delta < -10) return "danger"; // Significantly negative
	if (delta < -5) return "danger"; // Moderately negative
	if (delta < 0) return "warning"; // Slightly negative
	if (delta < 1) return "success"; // Slightly positive
	if (delta < 2) return "success"; // Moderately positive
	return "primary"; // Significantly positive
};

/** Change of the worked hours against the previous period, in percent; null without a base. */
export const hoursDelta = (
	current?: { workedHours: THoursStats },
	previous?: { workedHours: THoursStats }
): number | null => {
	if (!current || !previous || previous.workedHours.raw <= 0) return null;
	return (
		((current.workedHours.raw - previous.workedHours.raw) /
			previous.workedHours.raw) *
		100
	);
};
